import digitalData from 'digital-data';
import {
  BUTTON_SUBMISSION,
  BIA_MY_ACCOUNT,
  BIA_FILTER_BY,
  BIA_SEARCH,
  BIA_CARD_VIEW,
  BIA_TABLE_VIEW,
} from '../constants';

export const buyItAgain = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.timeFilter', ({ output }) => {
    const { timeFilter = '' } = output;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: BIA_FILTER_BY + `${timeFilter}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.search', ({ output }) => {
    const { dateRange = '', searchFilter = '', searchTerm = '' } = output;
    const searchBy = dateRange + ':' + searchFilter;
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: BIA_SEARCH,
        searchTerm,
        searchBy
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.pageView', ({ output }) => {
    const { view = 'Grid' } = output;
    const settings = view === 'Grid' ? BIA_CARD_VIEW : BIA_TABLE_VIEW;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('buy-it-again.quantityChange', ({ output }) => {
    const { type } = output; // field, up, down
    
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: {
        settings: `buy it again: quantity change: ${ type === 'field' ? 'quantity field': `increment ${ type } button`}`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};